import EmailVerificationResult from '@map/components/EmailVerification/EmailVerificationResult';
import ResetPassword from '@map/components/GuestArea/ResetPassword';
import NotFoundPage from '@map/components/NotFoundPage';
import { useCurrentUser } from '@map/hooks/userApi';
import CookieBanner from '@ui/CookieBanner';
import { useState } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { rootLinks } from '../app/links';
import PrivacyDialog from '../Profile/Privacy/PrivacyDialog';
import Authentication from './Authentication';
import { guestLinks } from './links';
import WelcomePage from './WelcomePage';

const GuestArea = () => {
  const user = useCurrentUser();
  const [open, setOpen] = useState(false);

  return (
    <>
      <CookieBanner onLinkClick={() => setOpen(true)} />
      {open && <PrivacyDialog open={open} close={() => setOpen(false)} />}
      <Switch>
        <Route
          exact
          path={guestLinks.emailVerification()}
          render={() => <EmailVerificationResult to={rootLinks.inner()} />}
        />
        <Route
          exact
          path={guestLinks.root()}
          render={() => (!!user.id ? <Redirect to={rootLinks.inner()} /> : <WelcomePage />)}
        />
        <Route path={guestLinks.resetPassword()} component={ResetPassword} />
        <Route path={guestLinks.authentication()} component={Authentication} />
        <Route component={NotFoundPage} />
      </Switch>
    </>
  );
};

export default GuestArea;
